<template>
  <div>
    <questions edit />
  </div>
</template>

<script>
import questions from "@/components/createReport/chooseCompany/chooseProduct/questions/index.vue";
export default {
  components: {
    questions,
  },
};
</script>

<style>
</style>